/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

import {MOEntityMeta} from './MOEntityMeta';
import {ColumnType, MetaColumn, MetaIndex} from '../defEntity/';
import {ArbreTravail} from '../entity';

/**
 * Arbre de décision pour le type travail Meta Entity.
 */
export class ArbreTravailMeta implements MOEntityMeta<ArbreTravail> {
    /**
     * Instance
     */
    private static _instance: ArbreTravailMeta = new ArbreTravailMeta();
    /**
     * Class.
     */
    private _classEntity: new(...args: any[]) => ArbreTravail = ArbreTravail;
    /**
     * Table Name
     */
    private _tableName: string = 'lemken_rouleaux_201907_arbre_travail';
    /**
     * Sync Data Server to Client
     */
    private _syncDataServerToClient: boolean = true;
    /**
     * Sync Data Client to Server
     */
    private _syncDataClientToServer: boolean = false;
    /**
     * Sync File Server to Client
     */
    private _syncFileServerToClient: boolean = true;
    /**
     * Sync File Client to Server
     */
    private _syncFileClientToServer: boolean = false;
    /**
     * Uuid
     */
    private _uuid: MetaColumn = {
        name        : '_uuid',
        type        : ColumnType.UUID,
        propertyName: '_uuid',
        primaryKey  : true
    };
    /**
     * Status
     */
    private _status: MetaColumn = {
        name        : '_status',
        type        : ColumnType.STATUS,
        propertyName: '_status',
    };
    /**
     * Timestamp
     */
    private _timeStamp: MetaColumn = {
        name        : '_time_stamp',
        type        : ColumnType.TIMESTAMP,
        propertyName: '_timeStamp',
    };
    /**
     * previous Server Id
     */
    private ___previousServerId: MetaColumn = {
        name        : '___previousServerId',
        type        : ColumnType.INTEGER,
        propertyName: '___previousServerId',
    };
    /**
     * Is New
     */
    private ___isNew: MetaColumn = {
        name        : '___isNew',
        type        : ColumnType.BOOLEAN,
        propertyName: '___isNew',
    };

    /**
     * Code
     */
    private _code: MetaColumn = {
        name        : 'code',
        type        : ColumnType.STRING,
        propertyName: '_code',
        size        : 64,
        index       : false
    };
    /**
     * Code Type Travail
     */
    private _codeTravail: MetaColumn = {
        name        : 'code_travail',
        type        : ColumnType.STRING,
        propertyName: '_codeTravail',
        size        : 64,
        index       : false
    };
    /**
     * Code Type Porté
     */
    private _codePorte: MetaColumn = {
        name        : 'code_porte',
        type        : ColumnType.STRING,
        propertyName: '_codePorte',
        size        : 64,
        index       : false
    };
    /**
     * Code Largeur
     */
    private _codeLargeur: MetaColumn = {
        name        : 'code_largeur',
        type        : ColumnType.STRING,
        propertyName: '_codeLargeur',
        size        : 64,
        index       : false
    };
    /**
     * Code Rouleau
     */
    private _codeRouleau: MetaColumn = {
        name        : 'code_rouleau',
        type        : ColumnType.STRING,
        propertyName: '_codeRouleau',
        size        : 64,
        index       : false
    };
    /**
     * Freinage
     */
    private _freinage: MetaColumn = {
        name        : 'freinage',
        type        : ColumnType.BOOLEAN,
        propertyName: '_freinage',
        size        : 1,
        index       : false
    };


    /**
     * uuid Index
     */
    private _uuidIndex: MetaIndex = new MetaIndex('_uuid');

    /**
     * Columns
     */
    private _columns: { [key: string]: MetaColumn; } = {
        _uuid                                   : this._uuid,
        _status                                 : this._status,
        _timeStamp                              : this._timeStamp,
        ___previousServerId                     : this.___previousServerId,
        ___isNew                                : this.___isNew,
        _code                                   : this._code,
        _codeTravail                            : this._codeTravail,
        _codePorte                              : this._codePorte,
        _codeLargeur                            : this._codeLargeur,
        _codeRouleau                            : this._codeRouleau,
        _freinage                               : this._freinage,
    };

    /**
     *  Get Instance
     */
    public static get instance(): ArbreTravailMeta {
        return this._instance;
    }

    /**
     *  Get Class Entity
     */
    public get classEntity(): new(...args: any[]) => ArbreTravail {
        return this._classEntity;
    }

    /**
     *  Get Table Name
     */
    public get tableName(): string {
        return this._tableName;
    }

    /**
     *  Get syncDataServerToClient
     */
    public get syncDataServerToClient(): boolean {
        return this._syncDataServerToClient;
    }

    /**
     *  Get syncDataClientToServer
     */
    public get syncDataClientToServer(): boolean {
        return this._syncDataClientToServer;
    }

    /**
     *  Get syncFileServerToClient
     */
    public get syncFileServerToClient(): boolean {
        return this._syncFileServerToClient;
    }

    /**
     *  Get syncFileClientToServer
     */
    public get syncFileClientToServer(): boolean {
        return this._syncFileClientToServer;
    }

    /**
     *  Get uuid
     */
    public get uuid(): MetaColumn {
        return this._uuid;
    }

    /**
     *  Get status
     */
    public get status(): MetaColumn {
        return this._status;
    }

    /**
     *  Get timeStamp
     */
    public get timeStamp(): MetaColumn {
        return this._timeStamp;
    }

    /**
     *  Get __previousServerId
     */
    public get __previousServerId(): MetaColumn {
        return this.___previousServerId;
    }

    /**
     *  Get __isNew
     */
    public get __isNew(): MetaColumn {
        return this.___isNew;
    }

    /**
     *  Get uuidIndex
     */
    public get uuidIndex(): MetaIndex {
        return this._uuidIndex;
    }


    /**
     *  Get columns
     */
    public get columns(): { [p: string]: MetaColumn } {
        return this._columns;
    }


    /**
     *  Getter Code Meta
     */
    public get code(): MetaColumn {
        return this._code;
    }

    /**
     *  Getter Code Type Travail Meta
     */
    public get codeTravail(): MetaColumn {
        return this._codeTravail;
    }

    /**
     *  Getter Code Type Porté Meta
     */
    public get codePorte(): MetaColumn {
        return this._codePorte;
    }

    /**
     *  Getter Code Largeur Meta
     */
    public get codeLargeur(): MetaColumn {
        return this._codeLargeur;
    }

    /**
     *  Getter Code Rouleau Meta
     */
    public get codeRouleau(): MetaColumn {
        return this._codeRouleau;
    }

    /**
     *  Getter Freinage Meta
     */
    public get freinage(): MetaColumn {
        return this._freinage;
    }


}

